import { XMarkIcon } from '@heroicons/react/24/outline';
import { DateTime } from 'luxon';

import { useLocalStorage } from 'src/common/util/useLocalStorage/useLocalStorage';
import { useUserRoles } from 'src/features/auth/useUserRoles';

const STORAGE_KEY = 'pricingMovedNoticeSeen';

// Stored as an id rather than a boolean because getStorageValue falls back to
// its default on any falsy read.
const NOTICE_ID = 'payers-tab';

// TODO: delete this banner, its test and its mount in App.tsx after this date.
const SHOW_UNTIL = DateTime.fromISO('2026-11-14');

export function PricingMovedBanner() {
  const { isRestrictedSupport, isRideOrderingPortalUser } = useUserRoles();
  const [seen, setSeen] = useLocalStorage(STORAGE_KEY, '');

  // Neither role had a Pricing tab to lose.
  if (isRestrictedSupport || isRideOrderingPortalUser) {
    return null;
  }

  if (DateTime.now() > SHOW_UNTIL) {
    return null;
  }

  if (seen === NOTICE_ID) {
    return null;
  }

  return (
    <div
      data-testid="pricing-moved-banner"
      className="flex items-center justify-center gap-3 bg-primary-700 p-3 text-center text-base font-bold text-white"
    >
      <span>Pricing has moved. You will find it as a tab under Payers.</span>
      <button
        type="button"
        aria-label="Dismiss"
        data-testid="pricing-moved-banner-dismiss"
        onClick={() => setSeen(NOTICE_ID)}
      >
        <XMarkIcon className="h-5 w-5" />
      </button>
    </div>
  );
}
